import { IWorkers, IWorkersListItem, WorkersResponseType } from "@/entity/workers/workers.types";
import Status from "@/entity/status/status";

export default class Workers implements IWorkers {
    total: number;
    data: IWorkersListItem[] = [];
    constructor(data: WorkersResponseType) {
        this.total = data.total;

        for (let i = 0; i < data.data.length; i++) {

            const dta = {
                id: data.data[i].id,
                salon_id: data.data[i].salon_id,
                phone: data.data[i].phone,
                name: data.data[i].name,
                last_name: data.data[i].last_name,
                middle_name: data.data[i].middle_name,
                position_name: data.data[i].position_name,
                status_name: data.data[i].status_name,
                category_name: data.data[i].category_name,
                fio: data.data[i].fio,//this.fio(data.data[i].last_name, data.data[i].name, data.data[i].middle_name),
                position_id: data.data[i].position_id,
                status: new Status(data.data[i].status),
                position: data.data[i].position,
                category: data.data[i].cosmetolog_category,
                created_at: data.data[i].created_at,
                birth_date: data.data[i].birth_date,
                cosmetolog_category_id: data.data[i].cosmetolog_category_id,
                description: data.data[i].description,
                employment_date: data.data[i].employment_date,
                salary_schema_id: data.data[i].salary_schema_id,
                updated_at: data.data[i].updated_at,

                cosmetolog_category: data.data[i].cosmetolog_category,
                schedule: [],
            }

            Object.assign(dta['schedule'],data.data[i].schedule)
            this.data.push(dta);
        }
    }
    fio(l: string, n: string, m: string | null): string {
        let name = l + " " + n;
        if (m != null && m != "") {
            name += " " + m;
        }
        return name;
    }
}
